import type { UserModel } from '@/domain/models/user.js';
import type { UserProfile } from '@/shared/utils/format-status.js';

export function getUserProfileChips(row: UserModel): UserProfile[] {
    const profiles = [...new Set(row.assignments.map((a) => a.profile))];
    return profiles.length > 0 ? profiles : [row.profile];
}
